module.exports = __webpack_public_path__ + "img/employer_signup_hero_mobile.c69925ef.jpg";